// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1ssQ1","content":"RecentSearches_content__1zFHn"};